// @flow

import React from 'react';
import type { Node } from 'react';
import type { CmsMetaProps } from 'shared_components/cms/types';
import { meta as META_ENUM } from 'Enum';
import { MetaProvider } from 'shared_data/providers/meta/Meta';
import { META_SUBSCRIBER_NAME } from 'shared_services/riseart/meta/Meta';
import { LocationManager } from 'shared_services/riseart/url/Location';

export const CmsMeta = ({
  metaTitle,
  metaDescription,
  metaKeywords,
  pageTitle,
  locales,
}: CmsMetaProps): Node => {
  const canonicalURL = LocationManager.get('originWithPath');
  const hrefLangParams = locales
    ? locales.reduce(
        (accumulator, { localeCode, uri }) => {
          accumulator.absolute[localeCode] =
            (uri && `${LocationManager.get('origin')}${uri}`) || null;
          accumulator.relative[localeCode] = uri || null;

          return accumulator;
        },
        { absolute: {}, relative: {} },
      )
    : null;

  return (
    <MetaProvider
      metaSubscriber={META_SUBSCRIBER_NAME.CMS_META}
      meta={{
        [META_ENUM.METATYPE.LINK_CANONICAL]: canonicalURL,
        [META_ENUM.METATYPE.LINK_CANONICAL_REDIRECT]: LocationManager.get('uri'),
        [META_ENUM.METATYPE.LINK_HREFLANG]:
          hrefLangParams && hrefLangParams.absolute
            ? {
                type: 'generated',
                href: hrefLangParams.absolute,
              }
            : null,
        [META_ENUM.METATYPE.LINK_HREFLANG_REDIRECT]:
          hrefLangParams && hrefLangParams.relative
            ? {
                type: 'generated',
                href: hrefLangParams.relative,
              }
            : null,
        [META_ENUM.METATYPE.META_TITLE]: metaTitle,
        [META_ENUM.METATYPE.META_DESCRIPTION]: metaDescription,
        [META_ENUM.METATYPE.META_KEYWORDS]: metaKeywords,
        [META_ENUM.METATYPE.PAGE_TITLE]: pageTitle,
        [META_ENUM.METATYPE.META_OG_TITLE]: metaTitle,
        [META_ENUM.METATYPE.META_OG_DESCRIPTION]: metaDescription,
        [META_ENUM.METATYPE.META_OG_URL]: canonicalURL,
      }}
    />
  );
};
